module.exports = __webpack_public_path__ + "static/img/clothing_03.22f634a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/clothing/thumbnail/clothing_03.png
// module id = /6Hx
// module chunks = 0